module.exports = __webpack_public_path__ + "img/BlinkArt_Sword9_Green.ec208dcd.png";